import React from "react";
import ScaleLoader from "react-spinners/ScaleLoader";
import DataTable from 'react-data-table-component';

const TableComponent = (props)=>{
    const paginationComponentOptions = { rowsPerPageText: 'Filas por página:', rangeSeparatorText: 'de', noRowsPerPage: false, selectAllRowsItem: true, selectAllRowsItemText: 'Todo' }
    const pendingComponent =  (<div className="p-2"> <ScaleLoader color={'#254165'} loading={props.pending} height={35} width={4} radius={2} margin={2} /></div>);
    var headItem = (props.headItem==null)?null:props.headItem;

    return (
        <DataTable keyField={props.keyField} headings = {headItem}    
            columns={props.columns} data={props.data}        
            responsive={true} noDataComponent={"No se han encontrado registros"}
            progressPending={props.pending} progressComponent={pendingComponent}
            {...props}
        />
    )
}

export default TableComponent